import { useState } from "react"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import Toaster from "../../components/toaster"
import services from "../../services"

const emptyForm = { name: "", email: "", phoneNumber: "", subject: "", message: "" };

const ContactUs = () =>{
    const [form, setForm] = useState(emptyForm);
    const [submitting, setSubmitting] = useState(false);
    const [toaster, setToaster] = useState({ visiblity: "hide" });

    const showToaster = (type, title, text) => {
        setToaster({ visiblity: "show", type, title, text });
        setTimeout(() => setToaster({ visiblity: "hide" }), 3500);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name.trim() || !form.message.trim()) {
            showToaster("danger", "Missing details", "Please enter your name and a message.");
            return;
        }
        try {
            setSubmitting(true);
            await services.contact.CREATE_CONTACT({
                name: form.name.trim(),
                email: form.email.trim(),
                phoneNumber: form.phoneNumber.trim(),
                subject: form.subject.trim(),
                message: form.message.trim(),
            });
            showToaster("success", "Message sent", "Thanks for reaching out — we'll get back to you soon.");
            setForm(emptyForm);
        } catch (err) {
            showToaster("danger", "Could not send", "Something went wrong. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    return (<>
    <Header/>
<SideBar/>
        <main class="main">

        <div class="site-breadcrumb" style={{background: 'url(assets/img/breadcrumb/01.jpg)'}}>
            <div class="container">
                <h2 class="breadcrumb-title">Contact Us</h2>
                <ul class="breadcrumb-menu">
                    <li><a href="index.html">Home</a></li>
                    <li class="active">Contact Us</li>
                </ul>
            </div>
        </div>


        <div class="contact-area py-120">
            <div class="container">
                <div class="contact-content">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="contact-info">
                                <div class="contact-info-icon">
                                    <i class="fal fa-map-location-dot"></i>
                                </div>
                                <div class="contact-info-content">
                                    <h5>Office Address</h5>
                                    <p>Ratlam, MP, India</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="contact-info">
                                <div class="contact-info-icon">
                                    <i class="fal fa-phone-volume"></i>
                                </div>
                                <div class="contact-info-content">
                                    <h5>Call Us</h5>
                                    <p>+91 94795 25453</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="contact-info">
                                <div class="contact-info-icon">
                                    <i class="fal fa-envelopes"></i>
                                </div>
                                <div class="contact-info-content">
                                    <h5>Email Us</h5>
                                    <p><a href="mailto:car53app@gmail.com"
                                            class="__cf_email__"
                                            >car53app@gmail.com</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="contact-info">
                                <div class="contact-info-icon">
                                    <i class="fal fa-alarm-clock"></i>
                                </div>
                                <div class="contact-info-content">
                                    <h5>Open Time</h5>
                                    <p>Mon - Sat (10.00AM - 05.30PM)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact-wrapper">
                    <div class="row">
                        <div class="col-lg-6 align-self-center">
                            <div class="contact-img">
                                <img src="/assets/img/contact/01.jpg" alt/>
                            </div>
                        </div>
                        <div class="col-lg-6 align-self-center">
                            <div class="contact-form">
                                <div class="contact-form-header">
                                    <h2>Get in Touch with Cars53 - Your Trusted Travel Partner!</h2>
                                    <p>Have a question or need assistance? The Cars53 team is here to help! Founded in 2024,
Cars53 is dedicated to providing our customers in Madhya Pradesh and Rajasthan with
top-notch service and support.</p>
                                </div>
                                <form id="contact-form" onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="name"
                                                    value={form.name} onChange={handleChange}
                                                    placeholder="Your Name" required/>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input type="email" className="form-control" name="email"
                                                    value={form.email} onChange={handleChange}
                                                    placeholder="Your Email"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <input type="tel" className="form-control" name="phoneNumber"
                                            value={form.phoneNumber} onChange={handleChange}
                                            placeholder="Your Phone Number"/>
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" name="subject"
                                            value={form.subject} onChange={handleChange}
                                            placeholder="Your Subject"/>
                                    </div>
                                    <div className="form-group">
                                        <textarea name="message" cols="30" rows="5" className="form-control"
                                            value={form.message} onChange={handleChange}
                                            placeholder="Write Your Message" required></textarea>
                                    </div>
                                    <button type="submit" className="theme-btn" disabled={submitting}>
                                        {submitting ? "Sending..." : <>Send Message <i className="far fa-paper-plane"></i></>}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="contact-map">
            <iframe
                title="Cars53 location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96708.34194156103!2d-74.03927096447748!3d40.759040329405195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4a01c8df6fb3cb8!2sSolomon%20R.%20Guggenheim%20Museum!5e0!3m2!1sen!2sbd!4v1619410634508!5m2!1sen!2s"
                style={{border:'0'}} allowfullscreen loading="lazy"></iframe>
        </div>
    </main>
    <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
    <Footer/>
    </>)
}
export default ContactUs
